<template>
  <div class="informate">
    <Tabbar
      @toMore="toMore"
      :title="title"
      @titleClick="titleClick"
      :list="list"
      :enlishTitle="enlishTitle"
    ></Tabbar>
    <div class="info-content">
      <icon-wrap :url="url" class="info-conten-img"></icon-wrap>
      <span class="no-data" v-if="emptyOpt.isEmpty" v-empty="emptyOpt"></span>
      <div v-else class="info-left" @click="goToDetail(rightObj.id)">
        <div class="header">
          <div class="year">
            <span>{{ rightObj.year }}</span>
            <span>{{ rightObj.dayAndMon }}</span>
          </div>
          <span class="arrow">
            <i class="icon icon-jiantou"></i>
          </span>
        </div>
        <div class="title">
          {{ rightObj.title }}
        </div>
        <div class="des" v-html="rightObj.content"></div>
      </div>
      <div class="info-right">
        <span
          class="no-data"
          v-if="emptyOpt2.isEmpty"
          v-empty="emptyOpt2"
        ></span>
        <template v-else>
          <div
            class="text-wrap"
            @click="goToDetail(item.id)"
            :key="i"
            v-for="(item, i) in textList.slice(1)"
          >
            <div class="text-content">
              <div class="date">
                <span>{{ item.year }}</span>
                <span>{{ item.dayAndMon }}</span>
              </div>
              <div class="text">
                <span class="text-title">
                  {{ item.title }}
                </span>
                <span class="text-des" v-html="item.content"></span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Tabbar from './Tabbar.vue'
import { getSynthesizeList } from '@/api/MGeneralInfo'

export default {
  components: {
    Tabbar
  },
  data: () => ({
    emptyOpt: {
      isEmpty: false
    },
    emptyOpt2: {
      isEmpty: false
    },
    url: require('../../../assets/images/patentImg/首页新闻资讯图片.png'),
    title: '综合资讯',
    enlishTitle: 'Industry Information',
    list: [
      {
        name: '行业资讯',
        key: '1',
        id: 'industry'
      },
      {
        name: '政策制度',
        key: '2',
        id: 'dynamic'
      },
      {
        name: '产业分析',
        key: '3',
        id: 'notice'
      }
    ],
    params: {
      pageSize: 4,
      pageNum: 1,
      informationType: 1,
      orderByColumn: 'publishTime',
      isAsc: 'desc'
    },
    textList: [],
    rightObj: {}
  }),
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const { rows, code, total } = await getSynthesizeList(this.params)
      if (code === 200) {
        if (rows && rows.length > 0) {
          this.textList = []
          rows.forEach(item => {
            const year = moment(item.publishTime).format('YYYY')
            const dayAndMon = moment(item.publishTime).format('MM/DD')
            this.textList.push({
              year,
              dayAndMon,
              title: item.title,
              content: item.content,
              brief: item.brief,
              id: item.id
            })
          })
          this.url = rows && rows[0].fileVo ? rows[0].fileVo[0].url : require('../../../assets/images/patentImg/首页新闻资讯图片.png')
          this.rightObj = this.textList[0]
        } else {
          this.url = require('../../../assets/images/patentImg/首页新闻资讯图片.png') //当rows为空数组时缺省图设置
        }
      }
      this.emptyOpt.isEmpty = total <= 0
      this.emptyOpt2.isEmpty = total <= 1
    },
    titleClick({ key }) {
      this.url = ''
      this.params.informationType = key
      this.getList()
    },
    toMore({ key }) {
      this.$router.push({ path: '/generalInfo?', query: { informationType: key } })
    },
    goToDetail(id) {
      this.$router.push(`/generalInfo/detail?id=${id}`)
    }
  }
}
</script>
